import type { AgeBucket } from "@/lib/quizAudience";

/**
 * Age helpers shared by the birthday screen, the relative age-range screen,
 * and the flow builder. Extracted from AgeRangeIntro so both the legacy
 * stepper and the v3 flow compute buckets the same way — a drift here would
 * split the matching data between flows.
 */

export function ageFromBirthday(iso?: string): number | null {
  if (!iso) return null;
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const today = new Date();
  const y = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10);
  const d = parseInt(m[3], 10);
  let age = today.getFullYear() - y;
  if (
    today.getMonth() + 1 < mo ||
    (today.getMonth() + 1 === mo && today.getDate() < d)
  ) {
    age -= 1;
  }
  return age >= 0 ? age : null;
}

export function ageToBucket(age: number | null): AgeBucket | null {
  if (age == null) return null;
  if (age < 30) return "1829";
  if (age < 40) return "3039";
  if (age < 50) return "4049";
  return "50plus";
}

/**
 * Which age bucket's photo represents "younger" / "same" / "older" relative
 * to the user's own bucket. Edge buckets leave the impossible direction
 * undefined so the flow can hide that option.
 */
export const RELATIVE_PHOTO_BUCKETS: Record<
  AgeBucket,
  { younger?: AgeBucket; same: AgeBucket; older?: AgeBucket }
> = {
  "1829": { same: "1829", older: "3039" },
  "3039": { younger: "1829", same: "3039", older: "4049" },
  "4049": { younger: "3039", same: "4049", older: "50plus" },
  "50plus": { younger: "4049", same: "50plus" },
};
